module.exports = () => {
  return {
    name: {
      label: '标题名称',
      type: 'input',
      value: '',
    },
  };
};
